import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import 'moment/locale/es';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Routes from './components/Routes';
import registerServiceWorker from './registerServiceWorker';

const env = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
const isProduction = env === 'production';

const googleTag = "G-1FC9MCZKM1";

function loadGoogleAnalytics(){
    var ga = document.createElement('script'); 
    ga.type = 'text/javascript'; 
    ga.async = true;
    ga.src = 'https://www.googletagmanager.com/gtag/js?id=' + googleTag;

    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);
}

function gtag(){window.dataLayer.push(arguments);}

if(isProduction)
{
    loadGoogleAnalytics(); //Create the script 

    window.dataLayer = window.dataLayer || [];

    gtag('js', new Date());

    gtag('config', googleTag);
}


ReactDOM.render(<Routes />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js